import { View, Text, TouchableOpacity, Platform, Keyboard } from "react-native";
import React from "react";
import Modal from "react-native-modal";
import MyText from "../custom/MyText";
import { Feather } from "@expo/vector-icons";
import { danger } from "../../colors";
import { useDispatch } from "react-redux";
import { noModal } from "../../redux/modal/modalAction";
import { Alert } from "react-native-web";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";

export default function MyModal({ isVisible, headerText, children,width }) {
  const dispatch = useDispatch();

  return (
    <Modal isVisible={isVisible}>
      <TouchableOpacity
        style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        activeOpacity={1}
        onPress={(e) => {
      
          Keyboard.dismiss();
          e.preventDefault();
        }}
      >
        <View
          style={{
            width: width ? width : "94%",
            backgroundColor: "#fefefe",
            padding: 10,
            borderRadius: 10,
            minHeight: 200,
          }}
        >
          <View style={{ flexDirection: "row" }}>
            <TouchableOpacity onPress={() => dispatch(noModal())}>
              <Feather name="x" size={24} color={danger} />
            </TouchableOpacity>
            <MyText style={{ marginHorizontal: 10 }}>{headerText}</MyText>
          </View>
          <View>{children}</View>
        </View>
      </TouchableOpacity>
    </Modal>
  );
}
